import setCustomizationConfiguration from './set-customization-configuration';
import setSiteCustomization from './set-site-customization';
import addCustomColorPalette from './add-custom-color-palette';
import deleteCustomColorPalette from './delete-custom-color-palette';
import updateCustomColorPalette from './update-custom-color-palette';
import setColorPaletteConfig from './set-color-palette-config';
import setCurrentColorPaletteVersion from './set-current-color-palette-version';
import addCustomTextColor from './add-custom-text-color';
import addCustomColor from './add-custom-color';
import setCurrentButtonPresetVersion from './set-current-button-preset-version';
import setCurrentTheme from './set-current-theme';
import addCustomFontPair from './add-custom-font-pair';
import deleteCustomFontPair from './delete-custom-font-pair';
import updateCustomFontPair from './update-custom-font-pair';
import addCustomGradient from './add-custom-gradient';

export default {
  setCustomizationConfiguration,
  setSiteCustomization,
  addCustomColorPalette,
  deleteCustomColorPalette,
  updateCustomColorPalette,
  setColorPaletteConfig,
  setCurrentColorPaletteVersion,
  addCustomTextColor,
  addCustomColor,
  setCurrentButtonPresetVersion,
  setCurrentTheme,
  addCustomFontPair,
  deleteCustomFontPair,
  updateCustomFontPair,
  addCustomGradient,
};
